import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpoint = '/api/exportPoa';

const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const getExportPoa = async () => {
    try {
        const response = await api.get(`${baseUrl}${orgEndpoint}`);
        return {
            status: response.status,
            data: response.data.data,
            // periodos: [{ year: 2023, month: 7 }, { year: 2023, month: 8 }, ...]
            // El backend lo genera dinámicamente desde la BD
            periodos: response.data.periodos
        };
    } catch (error) {
        console.error('Error fetching data poa:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching poa'
        };
    }
};

export default getExportPoa;